import { ObservableResult } from '../../models/result.model';
import { ContactsDataService } from './contacts-data.service';
import {
  AvailableForConnect, ContactCompany,
  ContactMethod, ContactsHistory,
  ContactsMainModel,
  ContactsModel,
  ContactType, IHealthCheck, ILogOut, RelatedLeadsHistory
} from '../../models/contacts/contacts.model';

export class MockContactsDataService implements ContactsDataService {

  readonly contactTypes = [
    {
      Id: 1,
      Name: 'PLANER',
      Description: 'Planer'
    },
    {
      Id: 2,
      Name: 'BAUHERR',
      Description: 'Gewerblicher Bauherr'
    },
    {
      Id: 3,
      Name: 'ENDKUNDE PRIVAT',
      Description: 'Privater Bauherr'
    }
  ];

  readonly contactMethods = [
    {
      Id: 1,
      Name: 'PLANER',
      Description: 'Planer'
    },
    {
      Id: 2,
      Name: 'BAUHERR',
      Description: 'Gewerblicher Bauherr'
    },
    {
      Id: 3,
      Name: 'ENDKUNDE PRIVAT',
      Description: 'Privater Bauherr'
    }
  ];

  contact: any = {
    "Id": 2080,
    "ContactTypeId": 3,
    "ContactMethodId": 2,
    "FirstName": "Arsh",
    "LastName": "A",
    "Address": "German",
    "Email": "",
    "Phone": "5564646",
    "PhonePrefix": "32",
    "LanguageCode": "de",
    "TaxNumber": "fsdfsfs",
    "Anonymized": false,
    "SalutationId": 3,
    "ConsentMarketing": false,
    "ConsentThirdParties": false,
    "ContactTypeText": "Private client",
    "ContactMethodText": "Phone",
    "ContactMethodName": "TELEFON",
    "LanguageText": "German",
    "SalutationText": "Mr.",
    "Inactive": false,
    "CreTS": "2022-03-09T10:48:11Z",
    "ModTS": "2024-11-28T09:57:18Z"
  };

  contact2: any = {
    "Id": 2181,
    "ContactTypeId": 2,
    "ContactMethodId": 3,
    "FirstName": "TEST 1",
    "LastName": "LAST",
    "Address": "German",
    "Email": "",
    "Phone": "5463457",
    "PhonePrefix": "32",
    "LanguageCode": "en",
    "TaxNumber": "fsdfsfs",
    "Anonymized": false,
    "SalutationId": 3,
    "ConsentMarketing": false,
    "ConsentThirdParties": false,
    "ContactTypeText": "Private client",
    "ContactMethodText": "Phone",
    "ContactMethodName": "TELEFON",
    "LanguageText": "English",
    "SalutationText": "Mr.",
    "Inactive": false,
    "CreTS": "2022-03-09T10:48:11Z",
    "ModTS": "2024-11-28T09:57:18Z"
  };


  availableForConnect: AvailableForConnect[] = [{
    Id: 1,
    Email: "anna.meier@example.com",
    FirstName: "Anna",
    LastName: "Meier",
    CountryText: "Germany",
  }];

  contactsHistory: ContactsHistory[] = [
    {
      ConsentMarketing: true,
      ConsentThirdParties: false,
      Editor: {
        Id: 101,
        FirstName: "John",
        LastName: "Doe",
        Organisation: "Marketing Department",
        Email: "john.doe@marketing.com",
        Phone: "+49 30 12345678",
        LanguageCode: "en",
        AvatarURL: "https://example.com/avatars/john_doe.jpg",
      },
      Timestamp: "2025-05-01T12:00:00Z"
    },
    {
      ConsentMarketing: false,
      ConsentThirdParties: true,
      Editor: {
        Id: 102,
        FirstName: "Anna",
        LastName: "Smith",
        Organisation: "Sales Team",
        Email: "anna.smith@sales.com",
        Phone: "+49 40 98765432",
        LanguageCode: "de",
        AvatarURL: "https://example.com/avatars/anna_smith.jpg",
      },
      Timestamp: "2025-05-02T09:15:00Z"
    },
    {
      ConsentMarketing: true,
      ConsentThirdParties: true,
      Editor: {
        Id: 103,
        FirstName: "Mike",
        LastName: "Johnson",
        Organisation: "Support Services",
        Email: "mike.johnson@support.com",
        Phone: "+49 89 11223344",
        LanguageCode: "en",
        AvatarURL: "https://example.com/avatars/mike_johnson.jpg",
      },
      Timestamp: "2025-05-03T08:30:00Z"
    }
  ];

  relatedLeads: RelatedLeadsHistory[] = [
    {
      Id: 18983,
      Number: "20250727412",
      LeadTypeId: 45,
      LeadTypeText: "Brochure",
      Articles: [
        {
          Id: 1568,
          Article: "B-11597",
          Description: "Windows Glass walls\n665-10-00-07"
        },
      ],
      CreTs: "2022-03-09T10:48:11Z",
      Creator: {
        Id: 103,
        FirstName: "Mike",
        LastName: "Johnson",
        Organisation: "Support Services",
        Email: "mike.johnson@support.com",
        Phone: "+49 89 11223344",
        LanguageCode: "en",
        AvatarURL: "https://example.com/avatars/mike_johnson.jpg",
        Login: "test@login.com",
        Available: true,
        Inactive: false,
        NotificationsEnabled: false,
        AppointmentMailEnabled: false,
        ExternalMailCCEnabled: false,
        CompletedMailEnabled: false,
        LeadMailEnabled: false,
        EnableReporting: true,
        LastActivity: new Date()
      },
      Editor: {
        Id: 103,
        FirstName: "Mike",
        LastName: "Johnson",
        Organisation: "Support Services",
        Email: "mike.johnson@support.com",
        Phone: "+49 89 11223344",
        LanguageCode: "en",
        AvatarURL: "https://example.com/avatars/mike_johnson.jpg",
        Login: "test@login.com",
        Available: true,
        Inactive: false,
        NotificationsEnabled: false,
        AppointmentMailEnabled: false,
        ExternalMailCCEnabled: false,
        CompletedMailEnabled: false,
        LeadMailEnabled: false,
        EnableReporting: true,
        LastActivity: new Date()
      }
    }
  ];

  contactCompany: ContactCompany[] = [
    {
      Name: "Company A",
      Count: 10,
    },
    {
      Name: "Company B",
      Count: 5,
    },
  ]

  getContactTypes(): ObservableResult<ContactType[]> {
    return ObservableResult.ofSuccess(this.contactTypes);
  }

  getContactMethods(): ObservableResult<ContactMethod[]> {
    return ObservableResult.ofSuccess(this.contactMethods);
  }

  getContacts(id: number): ObservableResult<ContactsModel> {
    if (id === 2187) {
      return ObservableResult.ofSuccess(this.contact);
    }
    return ObservableResult.ofSuccess(this.contact2);
  }

  editContact(contact: ContactsMainModel): ObservableResult<any> {
    return ObservableResult.ofSuccess();
  }

  getContactsByEmail(email: string): ObservableResult<ContactsModel> {
    return ObservableResult.ofSuccess(this.contact);
  }

  getAvailableForConnect(leadId: number, search?: string): ObservableResult<AvailableForConnect[]> {
    return ObservableResult.ofSuccess(this.availableForConnect);
  }

  connectContact(contactId: number, leadId?: number): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  connectNewContact(leadId: number, contact: ContactsMainModel): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  disconnectContact(contactId: number, leadId?: number): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  healthCheck(): ObservableResult<IHealthCheck> {
    return ObservableResult.ofSuccess();
  }

  logOut(token: string): ObservableResult<ILogOut> {
    return ObservableResult.ofSuccess();
  }

  getContactHistory(id: number): ObservableResult<ContactsHistory[]> {
    return ObservableResult.ofSuccess(this.contactsHistory);
  }

  getRelatedLeads(id: number): ObservableResult<RelatedLeadsHistory[]> {
    return ObservableResult.ofSuccess(this.relatedLeads);
  }

  getContactCompanies(searchTerm?: string): ObservableResult<ContactCompany[]> {
    return ObservableResult.ofSuccess(this.contactCompany);
  }
}
